export default __webpack_public_path__ + "static/media/AMZ2.0c43d879.png";